/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  ResetOktaResourceConnectionRequestBody,
  ResetOktaResourceConnectionRequestBody$Outbound,
  ResetOktaResourceConnectionRequestBody$outboundSchema,
} from "../components/resetoktaresourceconnectionrequestbody.js";

export type ResetOktaResourceConnectionSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type ResetOktaResourceConnectionRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  resetOktaResourceConnectionRequestBody:
    ResetOktaResourceConnectionRequestBody;
};

/** @internal */
export type ResetOktaResourceConnectionSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const ResetOktaResourceConnectionSecurity$outboundSchema: z.ZodMiniType<
  ResetOktaResourceConnectionSecurity$Outbound,
  ResetOktaResourceConnectionSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function resetOktaResourceConnectionSecurityToJSON(
  resetOktaResourceConnectionSecurity: ResetOktaResourceConnectionSecurity,
): string {
  return JSON.stringify(
    ResetOktaResourceConnectionSecurity$outboundSchema.parse(
      resetOktaResourceConnectionSecurity,
    ),
  );
}

/** @internal */
export type ResetOktaResourceConnectionRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  ResetOktaResourceConnectionRequestBody:
    ResetOktaResourceConnectionRequestBody$Outbound;
};

/** @internal */
export const ResetOktaResourceConnectionRequest$outboundSchema: z.ZodMiniType<
  ResetOktaResourceConnectionRequest$Outbound,
  ResetOktaResourceConnectionRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    resetOktaResourceConnectionRequestBody:
      ResetOktaResourceConnectionRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      resetOktaResourceConnectionRequestBody:
        "ResetOktaResourceConnectionRequestBody",
    });
  }),
);

export function resetOktaResourceConnectionRequestToJSON(
  resetOktaResourceConnectionRequest: ResetOktaResourceConnectionRequest,
): string {
  return JSON.stringify(
    ResetOktaResourceConnectionRequest$outboundSchema.parse(
      resetOktaResourceConnectionRequest,
    ),
  );
}
